(ns frontend.ui.page.lp-report-editor.step-1-initialization.view
  (:require
   [frontend.ui.page.lp-report-editor.style :as editor-style]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [frontend.ui.page.lp-report-editor.common.view :refer [footer continue-button]]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [herb.core :refer [<class]]
   [frontend.ui.component.grid.view :as grid]
   [common.localization :as loc]
   [re-frame.core :as rf]
   [frontend.ui.component.modal-dialog.view :as modal-dialog]
   [ui.components.button.view :as button]
   [frontend.ui.page.lp-report-editor.step-1-initialization.event :as event]
   [frontend.ui.page.lp-report-editor.step-1-initialization.sub :as sub]
   [frontend.ui.page.lp-report-editor.step-1-initialization.card.basic-config :as basic-config]
   [frontend.ui.page.lp-report-editor.step-1-initialization.card.fund-transfer-file :as
    fund-transfer-file]
   [frontend.ui.page.lp-report-editor.step-1-initialization.card.holding-configs :as holding-config]
   [frontend.ui.page.lp-report-editor.step-1-initialization.card.feeder-configs :as feeder-config]))

(defn step-footer
  []
  (let [can-edit? @(rf/subscribe [::sub/can-edit? :step-1])
        can-disable? @(rf/subscribe [::sub/can-disable-cycle?])
        can-begin-cycle? @(rf/subscribe [::sub/can-begin-cycle?])
        report @(rf/subscribe [::editor-sub/lp-report])]
    [footer
     {:left-content
      [continue-button]
      :right-content
      (when (or can-edit? can-disable?)
        [:<>
         (when-let [visible? @(rf/subscribe [::sub/delete-dialog-visible?])]
           [modal-dialog/confirm-dialog
            {:visible?           visible?
             :size               :xs
             :hide!              #(rf/dispatch [::event/hide-delete-dialog])
             :header-label       (loc/tr :confirm-lp-report-delete-dialog-title)
             :confirm-text       (loc/tr :confirm-lp-report-delete-dialog-text)
             :ok-button-text     (loc/tr :ok)
             :cancel-button-text (loc/tr :cancel)
             :on-confirm         #(rf/dispatch [::event/disable-lp-report report])
             :on-cancel          #(rf/dispatch [::event/hide-delete-dialog])}])
         [:div
          {:class (<class common-style/spacing-left)}
          [button/danger-solid
           {:on-click #(rf/dispatch [::event/start-delete-cycle])}
           (loc/tr :delete-cycle)]]
         (when (= :lp-report.step/initialization (:lp-report/step report))
           [:div
            {:class (<class common-style/spacing-left)}
            [button/primary-solid
             {:disabled? (not can-begin-cycle?)
              :on-click  #(rf/dispatch [::event/begin-report-cycle (:db/id report)])}
             (loc/tr :begin-cycle)]])])}]))

(defn body
  []
  (let [feeder-in-use? @(rf/subscribe [::editor-sub/feeder-in-use?])]
    [:<>
     [:div
      {:class (<class editor-style/page-body)}
      [grid/container {:breakpoint :xlarge}

       [basic-config/view]
       [fund-transfer-file/view]
       [holding-config/view]
       (when feeder-in-use?
         [feeder-config/view])]]
     [step-footer]]))
